import { createContext, useContext, useState, useEffect } from 'react';
import api from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAdult, setIsAdult] = useState(() => localStorage.getItem('age_status') === 'adult');

  const verifyAge = (status) => {
    localStorage.setItem('age_status', status);
    setIsAdult(status === 'adult');
  };

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      api.get('/auth/me').then(res => {
        setUser(res.data);
      }).catch(() => {
        localStorage.removeItem('auth_token');
      }).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (credentials) => {
    // credentials can be { phone, password } or { email, password }
    const res = await api.post('/auth/login', credentials);
    localStorage.setItem('auth_token', res.data.token);
    setUser(res.data);
    return res.data;
  };

  const register = async (name, phone, password, email = '') => {
    const res = await api.post('/auth/register', { name, phone, password, email });
    localStorage.setItem('auth_token', res.data.token);
    setUser(res.data);
    return res.data;
  };

  const logout = async () => {
    try { await api.post('/auth/logout'); } catch {}
    localStorage.removeItem('auth_token');
    setUser(null);
  };

  // Called after server actions that rotate the token (e.g., change email)
  const refreshSession = async (newToken) => {
    if (newToken) localStorage.setItem('auth_token', newToken);
    try {
      const res = await api.get('/auth/me');
      setUser(res.data);
      return res.data;
    } catch {
      return null;
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, setUser, refreshSession, isAdult, verifyAge }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
